import { Dexie, Table } from "dexie";
import { JsVersion } from "./jsVersion";
import { PrintBatch, PrintBatchTask, PrintResult, WaybillNoDocumentNumberResult } from "./tables";

export class ECDexie extends Dexie {
    /**
     * 打印批次表
     */
    printBatches!: Table<PrintBatch, number>;

    printBatchTasks!: Table<PrintBatchTask, number>;

    /**
     * 打印结果表
     */
    printResults!: Table<PrintResult, number>;

    /**
     * 快递单打印序号表
     */
    waybillNoDocumentNumberResults!: Table<WaybillNoDocumentNumberResult, number>;

    jsVersions!: Table<JsVersion, number>;

    constructor() {
        super("ship-easy");

        this.version(0.2)
            .stores({
                printBatches: "++id",
                printBatchTasks: "++id, batchId, printTaskId",
                printResults: "++id, batchId, printTaskId, waybillNo",
                waybillNoDocumentNumberResults: "++id, waybillNo",
                jsVersions: "++id, version",
            })
            // 升级的时候直接清除table数据
            .upgrade((trans) => {
                trans.db.tables.forEach((table) => {
                    if (table.name !== "waybillNoDocumentNumberResults") {
                        table.clear();
                    }
                });
            });
    }
}

export const db = new ECDexie();
